import { useMemo } from 'react'
import { UnifiedFilterModule } from '@core/modules/filters/unified-filter.module'
import { TGenericFilterType } from '@core/modules/filters'

export interface UseUnifiedFilterProps {
    filterModule: UnifiedFilterModule
    data?: any[]
}

export const useUnifiedFilter = ({
    filterModule,
    data = [],
}: UseUnifiedFilterProps) => {
    const { filter, search } = filterModule.useStore()

    const filterConfig = useMemo(
        () => filterModule.getFilterConfig(),
        [filterModule]
    )
    const hasActiveFilters = useMemo(
        () => filterModule.hasActiveFilters(),
        [filterModule, filter, search]
    )
    const activeFilterCounts = useMemo(
        () => filterModule.getActiveFilterCounts(),
        [filterModule, filter]
    )
    const activeFilters = useMemo(
        () => filterModule.getActiveFilters(),
        [filterModule, filter]
    )
    const processedData = useMemo(
        () => filterModule.processData(data),
        [filterModule, filter, search, data]
    )
    const allData = useMemo(
        () => filterModule.processData(data, true),
        [filterModule, data]
    )

    const handleFilterChange = (
        type: TGenericFilterType,
        selectedOptions: string[]
    ) => {
        filterModule.setFilter(type, selectedOptions)
    }

    const handleSearchChange = (value: string) => {
        filterModule.setSearchKey(value)
    }

    const handleFilterReset = () => {
        filterModule.clearAllFilters()
    }

    const getFilterOptions = (filterType: TGenericFilterType) => {
        return filterModule.getFilterOptionsAndState(filterType)
    }

    return {
        filter,
        search,
        data: processedData,
        allData,
        filterConfig,
        hasActiveFilters,
        activeFilterCounts,
        activeFilters,
        handleFilterChange,
        handleSearchChange,
        handleFilterReset,
        getFilterOptions,
    }
}
